enum NoYesUndecided {
    No = 0,
    Yes = 1,
    Undecided = 2
}

export { NoYesUndecided };
